import React from 'react';
import { Checkbox } from '@vtblife/uikit';
import { OptionType } from '@vtblife/uikit/legacy';

import { LivingFacilitiesOption } from '@search/filter-enums/enums/LivingFacilityOption';

import { LivingFacilityFilter } from '../../../../models/Filter';

interface ILivingFacilityButtonFilter {
    filter: LivingFacilityFilter;
    handleChange: (filter: LivingFacilityFilter) => void;
    classNameGroup?: string;
}

const OPTIONS_TYPE: OptionType<LivingFacilitiesOption>[] = [
    { label: 'Стиральная машина', value: LivingFacilitiesOption.WASHING_MACHINE },
    { label: 'Холодильник', value: LivingFacilitiesOption.FRIDGE },
    { label: 'Интернет', value: LivingFacilitiesOption.INTERNET },
    { label: 'Посудомоечная машина', value: LivingFacilitiesOption.DISHWASHER },
    { label: 'Телевизор', value: LivingFacilitiesOption.TV },
    { label: 'Кондиционер', value: LivingFacilitiesOption.AIR_CONDITIONER }
];

export const LivingFacilityButtonFilterView: React.FC<ILivingFacilityButtonFilter> = ({
    filter,
    handleChange,
    classNameGroup
}) => {
    const onChange = React.useCallback((value: boolean, optionType: LivingFacilitiesOption) => {
        const filters = new Set(filter.facilities);

        filters[value ? 'add' : 'delete'](optionType);
        handleChange(new LivingFacilityFilter(Array.from(filters)));
    }, [ handleChange, filter.facilities ]);

    return (
        <div className={classNameGroup}>
            {OPTIONS_TYPE.map(type => (
                <div
                    key={type.value}
                    style={{ width: 'fit-content' }}
                >
                    <Checkbox
                        name={type.label}
                        value={filter.facilities.includes(type.value)}
                        onChange={value => onChange(value, type.value)}
                        variant='filter'
                        block
                    >
                        {type.label}
                    </Checkbox>
                </div>
            ))}
        </div>
    );
};
